// @mui
import { Typography, Stack } from '@mui/material';
// components
import {Logo} from '../../components/logo';
import Image from '../../components/image';
//
import { StyledRoot, StyledSectionBg, StyledSection, StyledContent } from './styles';

// ----------------------------------------------------------------------

type Props = {
  title?: string;
  illustration?: string;
  children: React.ReactNode;
};

export default function LoginLayout({ children, illustration, title }: Props) {
  return (
    <StyledRoot>
      <Logo
        sx={{
          zIndex: 9,
          position: 'absolute',
          mt: { xs: 1.5, md: 5 },
          ml: { xs: 2, md: 5 },
          backgroundColor:"#FCFCFC"
        }}
      />

      <StyledSection>
        <Typography variant="h3" sx={{
          mb: 10,
          paddingLeft:"1rem",
          paddingRight:"1rem",
          maxWidth: {
            lg:780,
            md:480,
            sm:480,
            xs:480,
          },
          textAlign: 'center', wordBreak: "break-word"
        }}>
          {title || 'Hi, Welcome back'}
        </Typography>

        <Image
          disabledEffect
          visibleByDefault
          alt="auth"
          src={illustration || '/assets/illustrations/company_login_image.png'}
          sx={{ maxWidth: "100%" }}
        />

        <StyledSectionBg />
      </StyledSection>

      <StyledContent>
        <Stack sx={{ width: 1 }}> {children} </Stack>
      </StyledContent>
    </StyledRoot>
  );
}
